import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { IAuthenticationService } from "services/AuthenticationService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { IUsersService } from "services/UsersService";
import { toast } from "react-toastify";

const initialState = {
  VerifyingUser: false,
  IsInvalid: false,
  IsVerified: false,
};

export const cpl2UserLoginSlice = createSlice({
  name: "cpl2UserLogin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyUser.pending, (state) => {
        state.VerifyingUser = true;
      })
      .addCase(verifyUser.fulfilled, (state, action) => {
        state.VerifyingUser = false;
        if (action.payload) {
          toast.success("Accounts linked successfully");
          state.IsInvalid = false;
          state.IsVerified = true;
        } else {
          state.IsInvalid = true;
        }
      })
      .addCase(verifyUser.rejected, (state) => {
        state.VerifyingUser = false;
      });
  },
});

export const verifyUser = createAsyncThunk(
  "cpl2UserLogin/verifyUser",
  async ({ username, password }: { username: string; password: string }) => {
    const authenticationService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
    const rpmUserID = await authenticationService.verifyRPMUser(username, password);
    if (rpmUserID) {
      const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
      await usersService.setRPMUserID(rpmUserID);
      await usersService.setUseConnectLogin(true, rpmUserID);
      return true;
    }
    return false;
  }
);

export const selectVerifyingUser = (state: RootState) => state.cpl2UserLogin.VerifyingUser;
export const selectIsInvalid = (state: RootState) => state.cpl2UserLogin.IsInvalid;
export const selectIsVerified = (state: RootState) => state.cpl2UserLogin.IsVerified;

export default cpl2UserLoginSlice.reducer;
